import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

/**
 * A route reuse strategy that never reuses routes
 * This ensures components are always destroyed when navigating away, helping with memory management
 */
export class NoReuseStrategy implements RouteReuseStrategy {
  /**
   * Determines if a route should be detached when navigating away
   * @returns Always false, meaning routes are never stored for later reuse
   */
  public shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  /**
   * Stores a detached route
   * Not used in this implementation since shouldDetach always returns false
   */
  public store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    // No implementation needed since we never detach routes
  }

  /**
   * Determines if a route should be reattached when navigating to it
   * @returns Always false, meaning we never reuse previously detached routes
   */
  public shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  /**
   * Retrieves a previously detached route
   * Not used in this implementation since shouldAttach always returns false
   */
  public retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  /**
   * Determines if a route should be reused
   * @returns True only if the future and current routes are the exact same object
   */
  public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    // Only reuse the route if it's the exact same route configuration
    return future.routeConfig === curr.routeConfig;
  }
}
